<div class="modal">
    <h1>¿Eliminar dirección?</h1>
    <p>Una vez eliminado no se podrá recuperar</p>
    <div class="group-button">
        <a (click)="closeDialog()" class="button normal">No eliminar</a>
        <a (click)="enviar()" class="button alert">Eliminar</a>
    </div>
</div>